import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import OpcoesPaginacao from '../comum/OpcoesPaginacao'
import alterarRegistrosPorPagina from '../../actions/cteos/alterarRegistrosPorPaginaCteOs'
import determinarPaginaAtual from '../../actions/cteos/determinarPaginaAtualCteOs'

export class PaginacaoCteOs extends Component {
  render () {
    return <OpcoesPaginacao
      registrosPorPagina={this.props.registrosPorPagina}
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      determinarPaginaAtual={this.props.determinarPaginaAtual}
      alterarRegistrosPorPagina={this.props.alterarRegistrosPorPagina}/>
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    alterarRegistrosPorPagina,
    determinarPaginaAtual
  }, dispatch)
}

export function mapStateToProps (state) {
  return {
    emissoesCteOs: state.emissoesCteOs.emissaoCteOS,
    total: state.emissoesCteOs.total,
    paginaAtual: state.paginaAtualCteOs,
    registrosPorPagina: state.registrosPorPaginalCteOs
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginacaoCteOs)
